import React from 'react';
import {Box, Stack, Switch, Typography} from "@mui/material";
import {alpha} from "@mui/material/styles";

interface IProps {
	label: string,
	hint?: string,
	checked: boolean,
	onChange: (checked: boolean) => void,
	disabled?: boolean,
}

/** A settings row: the text on the left, the switch on the right, the whole row clickable. */
const SettingSwitch = ({label, hint, checked, onChange, disabled}: IProps) => (
	<Stack
		component={'label'}
		direction={'row'}
		alignItems={'center'}
		justifyContent={'space-between'}
		gap={2}
		sx={(theme) => ({
			px: 1.5,
			py: 1,
			mx: -1.5,
			borderRadius: 2,
			cursor: disabled ? 'default' : 'pointer',
			transition: 'background-color .15s',
			'&:hover': disabled ? undefined : {bgcolor: alpha(theme.palette.primary.main, 0.05)},
		})}
	>
		<Box sx={{minWidth: 0}}>
			<Typography sx={{fontSize: 14, fontWeight: 500, lineHeight: 1.4}}>{label}</Typography>
			{hint && <Typography sx={{fontSize: 12.5, lineHeight: 1.4}} color={'text.secondary'}>{hint}</Typography>}
		</Box>
		<Switch
			checked={checked}
			disabled={disabled}
			onChange={(event) => onChange(event.target.checked)}
			sx={{flexShrink: 0}}
		/>
	</Stack>
);

export default SettingSwitch;
